import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import _uniqBy from "lodash/uniqBy";
import _isArray from "lodash/isArray";
import _uniqueId from "lodash/uniqueId";
import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { useDeepEffect } from '../hooks';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { commonStyles } from '../styles';
import { listLabel, listContainer, itemContainer, itemContent, deleteIconContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var List = /*#__PURE__*/forwardRef(function (props, reference) {
  var label = props.label,
      itemsProp = props.items,
      onDelete = props.onDelete,
      uniqueBy = props.uniqueBy,
      renderAddNew = props.renderAddNew,
      renderElement = props.renderElement,
      addNewLabel = props.addNewLabel,
      className = props.className;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEdit = _useState4[0],
      setIsEdit = _useState4[1];

  var selectedItemRef = useRef();

  var hasAddNew = _isFunction(renderAddNew);

  var addUuid = function addUuid(el) {
    return {
      value: el,
      uuid: uniqueBy ? el[uniqueBy] : _uniqueId()
    };
  };

  useImperativeHandle(reference, function () {
    return {
      getItems: function getItems() {
        return items.map(function (el) {
          return el.value;
        });
      },
      addItem: function addItem(newItem) {
        return handleCreateNew(newItem);
      },
      deleteItem: function deleteItem(uuid) {
        return _isArray(uuid) ? uuid.forEach(handleSoftDelete) : handleSoftDelete(uuid);
      },
      deleteAll: function deleteAll() {
        return setItems([]);
      }
    };
  });
  useDeepEffect(function () {
    setItems(_isArray(itemsProp) ? itemsProp.map(addUuid) : []);
  }, [itemsProp]);

  var handleDelete = function handleDelete(uuid) {
    var _items$find;

    _isFunction(onDelete) && onDelete((_items$find = items.find(function (el) {
      return el.uuid === uuid;
    })) === null || _items$find === void 0 ? void 0 : _items$find.value, handleCreateNew);
    handleSoftDelete(uuid);
  };

  var handleSoftDelete = function handleSoftDelete(uuid) {
    return setItems(function (prev) {
      return prev.filter(function (el) {
        return el.uuid !== uuid;
      });
    });
  };

  var handleCreateNew = function handleCreateNew(newElement) {
    setIsEdit(false);
    var newItem = _isArray(newElement) ? newElement.map(addUuid) : [addUuid(newElement)];
    setItems(function (prev) {
      return _uniqBy([].concat(_toConsumableArray(prev), _toConsumableArray(newItem)), 'uuid');
    });
    return newItem;
  };

  var handleEdit = function handleEdit(uuid, value) {
    setIsEdit(false);
    setItems(function (prev) {
      return prev.map(function (el) {
        return el.uuid !== uuid ? el : _objectSpread(_objectSpread({}, el), {}, {
          value: value
        });
      });
    });
  };

  return ___EmotionJSX("div", _extends({}, className && {
    className: className
  }, {
    css: commonStyles(props)
  }), label && ___EmotionJSX("h3", {
    css: listLabel
  }, label), !!(items !== null && items !== void 0 && items.length) && ___EmotionJSX("div", {
    css: listContainer(hasAddNew)
  }, items.map(function (el) {
    return ___EmotionJSX("div", {
      key: el.uuid,
      css: itemContainer
    }, ___EmotionJSX("div", {
      tabIndex: -1,
      role: "button",
      css: "deleteIcon ".concat(deleteIconContainer),
      onClick: function onClick() {
        return handleDelete(el.uuid);
      }
    }, ___EmotionJSX(Icon, {
      iconName: "la la-trash",
      color: "error",
      size: 22
    })), ___EmotionJSX("div", {
      css: itemContent
    }, _isFunction(renderElement) ? renderElement(el.value) : el.value));
  })), hasAddNew && (!isEdit ? ___EmotionJSX(Button, {
    leftIcon: {
      iconName: 'add',
      material: true,
      size: 15
    },
    small: true,
    clear: true,
    onClick: function onClick() {
      return setIsEdit(true);
    }
  }, addNewLabel !== null && addNewLabel !== void 0 ? addNewLabel : 'Add New Item') : renderAddNew({
    onCreate: handleCreateNew,
    onDelete: handleDelete,
    onEdit: handleEdit,
    onCancel: function onCancel() {
      return setIsEdit(false);
    },
    item: selectedItemRef.current
  })));
});
List.propTypes = {
  label: PropTypes.string,
  items: PropTypes.array,
  renderElement: PropTypes.func,
  renderAddNew: PropTypes.func,
  addNewLabel: PropTypes.string,
  onDelete: PropTypes.func,
  uniqueBy: PropTypes.string,
  className: PropTypes.string
};
export default List;